const initialPartnersState = {
    partnerCategories: [],
    flatCategories: [],
    partnerCategoriesLoaded: false,
    selectedCategory: null,
    partners: [],
    partnersLoaded: false,
    recentPartners: [],
    promoLoaded: false,
    promoData: []
}

const partnerReducer = (state = initialPartnersState, action) => {
    switch (action.type) {
        case 'LOAD_PARTNER_CATEGORIES':
            return Object.assign({}, state, {
                partnerCategories: action.partnerCategories,
                flatCategories: action.flatCategories,
                partnerCategoriesLoaded: true
            })
        case 'LOAD_PARTNERS':
            return Object.assign({}, state, {
                partners: action.partners,
                partnersLoaded: true
            })
        case 'SELECT_PARTNER_CATEGORY':
            return Object.assign({}, state, {
                selectedCategory: action.category
            })
        case 'RESET_PARTNER_DATA':
            return Object.assign({}, state, initialPartnersState)
        case 'UPDATE_RECENT_PARTNERS':
            return Object.assign({}, state, {
                recentPartners: action.recentPartners
            })
        case 'SHELL_ADD_BARCODE':
            return Object.assign({}, state, {
                promoLoaded: true,
                promoData: {
                    shellBarcode : action.barcodeNo
                }
            })
        case 'PROMO_RESET':
            return Object.assign({}, state, {
                promoLoaded: false
            })
        default:
            return state
    }
}

export default partnerReducer;